<template>
  <form-button
    variant="custom"
    mode="default"
    class="add-to-calendar-button"
    :class="{ disabled: iCalError }"
    tabindex="0"
    :full-width="true"
    :color-overrides="colorOverrides"
    :aria-label="$t('events.addToCalendarOptionAriaLabel', { calendarType: $t(`events.calendarType.${calendarType}`) })"
    @click.stop.prevent="handleAddToCalendarAction"
    @keydown.enter.exact.stop="handleAddToCalendarAction"
  >
    {{ $t(`events.calendarType.${calendarType}`) }}
  </form-button>
</template>

<script>
import dayjs from 'dayjs';
import {
  CALENDARS,
  validate,
  buildICalEvent,
  downloadToFile,
  buildOnlineCalendarUrl,
} from '../../../../../helpers/calendar.helper';
import FormButton from '../../../../global/Forms/FormButton';

export default {
  name: 'AddToCalendar',
  components: { FormButton },
  props: {
    calendarType: {
      type: String,
      default: CALENDARS.Google,
      validator: validate(CALENDARS),
    },
    eventData: {
      type: Object,
      default: () => ({}),
    },
    colorOverrides: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      CALENDARS,
      iCalError: false,
    };
  },
  methods: {
    iCalDownload(content) {
      downloadToFile(content, `${this.eventData.title}.ics`);
    },
    handleAddToCalendarAction() {
      if (this.iCalError) {
        return;
      }
      if (this.calendarType === CALENDARS.iCal) {
        const iCalResult = buildICalEvent(this.eventData);
        if (iCalResult.error?.errors.length > 0) {
          console.error(...iCalResult.error.errors);
          this.iCalError = true;
          return;
        }
        this.iCalDownload(iCalResult.value);
        return;
      }
      if (this.eventData.type === 'event') {
        window.open(buildOnlineCalendarUrl(this.calendarType, this.eventData), '_blank');
        return;
      }
      const description =
        this.eventData.home_team && this.eventData.away_team
          ? `${this.eventData.home_team} ${this.eventData.versus ? 'vs' : ''} ${this.eventData.away_team}`
          : '';

      const athleticsTitle =
        this.eventData.title ||
        `${this.eventData.home_team} ${this.eventData.versus ? 'vs' : ''} ${this.eventData.away_team}`;

      const athleticsData = {
        title: athleticsTitle,
        start_at: this.eventData.event_date,
        end_at: dayjs(this.eventData.event_date).add(30, 'minutes').format(),
        location: this.eventData?.location || '',
        details: this.eventData?.details || description,
        all_day: false,
      };
      window.open(buildOnlineCalendarUrl(this.calendarType, athleticsData), '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
@use '../../../../global/scss/color_vars';
.add-to-calendar-button {
  &:hover {
    color: #ffffff;
  }
  &.disabled {
    background-color: color_vars.$color-grey-10;
    color: color_vars.$color-grey-40;
  }
}
</style>
